__turbopack_context__.v({
  "accordionSlideOverwrite": "calendarDropdown-module-scss-module__ErMWgG__accordionSlideOverwrite",
  "calendarDropdown": "calendarDropdown-module-scss-module__ErMWgG__calendarDropdown",
  "fadeIn": "calendarDropdown-module-scss-module__ErMWgG__fadeIn",
  "fadeOut": "calendarDropdown-module-scss-module__ErMWgG__fadeOut",
  "navButton": "calendarDropdown-module-scss-module__ErMWgG__navButton",
  "scaleIn": "calendarDropdown-module-scss-module__ErMWgG__scaleIn",
  "scaleOut": "calendarDropdown-module-scss-module__ErMWgG__scaleOut",
  "zoomIn": "calendarDropdown-module-scss-module__ErMWgG__zoomIn",
  "zoomOut": "calendarDropdown-module-scss-module__ErMWgG__zoomOut",
});
